import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProfileDropdown from './ProfileDropdown';

interface AppHeaderProps {
  showWelcome?: boolean;
  userProgress?: any;
}

const AppHeader: React.FC<AppHeaderProps> = ({ showWelcome = false, userProgress }) => {
  const location = useLocation();
  const { user } = useAuth();
  const isLearnPage = location.pathname.includes('/learn');
  const maxWidth = isLearnPage ? 'max-w-7xl' : 'max-w-6xl';

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className={`${maxWidth} mx-auto px-2 sm:px-4 lg:px-6 py-2 sm:py-3 lg:py-4`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4">
            <Link to="/" className="flex items-center space-x-1 sm:space-x-2 hover:opacity-80 transition-opacity flex-shrink-0">
              <img src="/apple-touch-icon.png" alt="EightyThreeLabs" className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8" />
              <span className="text-sm sm:text-lg lg:text-xl font-semibold">
                <span className="text-brand-primary">EightyThree</span>
                <span className="text-black dark:text-white">Labs</span>
              </span>
            </Link>
          </div>
          
          <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4">
            <ProfileDropdown />
          </div>
        </div>
        
        {/* Welcome Section for Learn Pages */}
        {showWelcome && isLearnPage && (
          <div className="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-gray-200 dark:border-gray-700">
            <div className="flex items-center space-x-3 sm:space-x-4 lg:space-x-6">
              <div className="text-right">
                <div className="text-xs sm:text-sm font-semibold text-gray-800 dark:text-gray-100">
                  Welcome back, {user?.firstName}!
                </div>
                {userProgress && (
                  <div className="text-xs text-gray-500 dark:text-gray-300">
                    Level {userProgress.currentLevel}
                  </div>
                )}
              </div>
              <Link to="/" className="text-sm sm:text-base text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                Home
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default AppHeader;